import { httpsCallable } from "firebase/functions";
import { getFirebaseFunctions } from "../../firebase.ts";
import type { Factoring } from "components/factoringModel";
import { useState, useEffect } from "react";

interface Request {
}

interface Response {
  success: boolean;
  factoring: Factoring | null;
}

interface PreviousFactoringResult {
  data: Factoring | null;
  loading: boolean;
  error: Error | null;
}

export const usePreviousFactoring = (): PreviousFactoringResult => {
  const [data, setData] = useState<Factoring | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const functions = getFirebaseFunctions();
        const getPreviousFactoringFunction = httpsCallable<Request, Response>(
          functions,
          "getPreviousFactoring"
        );

        const result = await getPreviousFactoringFunction({});
        setData(result.data.factoring);
      } catch (err) {
        console.error("Error fetching previous factoring data:", err);
        setError(err instanceof Error ? err : new Error(String(err)));
      } finally {
        // setDataとsetLoadingが同じタイミングのレンダリングの場合、STEP1にdesiredAmountが反映されない
        setTimeout(() => setLoading(false), 1);
      }
    };

    fetchData();
  }, []);

  return { data, loading, error };
};
